<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">
                    <h2 class="mb-4">
                        Esther
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that God is at work in all things, both good and bad, for the good of his people.
                        </li>
                        <li>
                            To understand that we can trust God because his plans and timing are far better than our own.
                        </li>
                        <li>
                            To understand that God always defeats his enemies and rescues his people, no matter how impossible it might seem.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series looks at the story of Esther and God’s great deliverance of his people.
                        There are two opposite and opposing plans at work throughout the book:
                    </p>
                    <p>
                        <strong>Haman’s Plan</strong> – Haman’s pride and anger led him to plot the destruction of
                        Mordecai and all his people, the Jews (weeks 1, 2 and 3). Although his plans were well underway
                        he tried to hurry Mordecai’s death by building a gallows/pole on which to hang/impale him (week 2).
                        Haman’s plan to kill the Jews posed a threat even after his own death, but in the end all of his plotting
                        came to nothing (weeks 2 and 3).
                    </p>
                    <p>
                        <strong>God’s Plan</strong> – although God is not referred to by name it is his plan which triumphs.
                        He was at work behind the scenes through Esther becoming queen and the casting of the lots (week 1);
                        Mordecai rescuing the king and his reward (weeks 1 and 2); Esther’s appeal to the king and Haman’s defeat (week 2);
                        and the new law which allowed the Jews to defend themselves (week 3). The success of God’s plan to preserve his people
                        is still remembered and celebrated today.
                    </p>

                    <p>
                        The story of Esther teaches us that no enemy can stand against God’s plan.
                        This should encourage us today when God seems hidden in the world.
                        Events take their normal course and miracles may seem few and far between,
                        but this doesn't mean that God is absent. He is always at work, both in good and bad situations,
                        for the ultimate good of his people.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - The King's Feast (Esther 1:1-4:17)
                    </p>
                    <p>
                        Lesson 2 - The Queen's Feast (Esther 5:1-7:10)
                    </p>
                    <p>
                        Lesson 3 - The Jews' Feast (Esther 8:1-10:3)
                    </p>
                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Esther",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Esther`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that God is at work in all things, both good and bad, for the good of his people.",
                },
            ],
        };
    },
};
</script>
